export function afterDomBuilt(listener: () => void) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', listener)
    } else {
        listener()
    }
}

const searchParams = new URLSearchParams(window.location.search)

// Note: empty search param value will also be fallback-ed
export function searchOrFallback(param: string, fallback: string): string {
    return searchParams.get(param) || fallback
}

/* Padding zeros */
function padZeros(input: number | string, count: number) {
    return ('' + input).padStart(count, '0')
}

export const pad2 = (input: number | string) => padZeros(input, 2)
export const pad4 = (input: number | string) => padZeros(input, 4)
